export enum courseStatusEum {
    SAVE_DRAFT = 1,
    WAIT_APPROVE = 2,
    APPROVED = 3,
    REFUSE = 4,
    PUBLISHED = 5,
    END = 6,
}